import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  IDsTreeItem,
  ITranslations,
  ITranslationsRequest,
} from './translations.interfaces';
import { Observable } from 'rxjs';
import { skipGlobalErrorToast } from '../../common/http/skip-global-error.token';

@Injectable({
  providedIn: 'root',
})
export class TranslationsService {
  private readonly http = inject(HttpClient);

  public getTranslations(): Observable<ITranslations> {
    return this.http.get<ITranslations>(
      `${environment.services.masterdata}/api/translations`
    );
  }

  public createTranslation(
    data: ITranslationsRequest
  ): Observable<ITranslationsRequest> {
    return this.http.post<ITranslationsRequest>(
      `${environment.services.masterdata}/api/translations`,
      { ...data },
      {
        headers: { 'Content-Type': 'application/json' },
        context: skipGlobalErrorToast(),
      }
    );
  }

  public updateTranslation(
    data: ITranslationsRequest
  ): Observable<ITranslationsRequest> {
    return this.http.put<ITranslationsRequest>(
      `${environment.services.masterdata}/api/translations`,
      { ...data },
      {
        headers: { 'Content-Type': 'application/json' },
        context: skipGlobalErrorToast(),
      }
    );
  }

  public deleteTranslation(data: ITranslationsRequest): Observable<void> {
    return this.http.delete<void>(
      `${environment.services.masterdata}/api/translations`,
      { body: data, context: skipGlobalErrorToast() }
    );
  }
}

export const parseTranslationToTreeItem = (
  input: ITranslations
): IDsTreeItem[] => {
  const tree: IDsTreeItem[] = [];

  const findOrCreateNode = (
    nodes: IDsTreeItem[],
    id: string,
    label: string
  ): IDsTreeItem => {
    let node = nodes.find((candidate) => candidate.id === id);
    if (!node) {
      node = { id, label, children: [], values: {} };
      nodes.push(node);
    }
    return node;
  };

  for (const locale in input) {
    for (const namespace in input[locale]) {
      for (const key in input[locale][namespace]) {
        const value = input[locale][namespace][key];

        const namespaceParts = namespace.split('.');
        const fullId = `${namespace}.${key}`;
        let currentNodes = tree;
        let currentId = '';

        namespaceParts.forEach((part, index) => {
          currentId = index === 0 ? part : `${currentId}.${part}`;
          const currentNode = findOrCreateNode(currentNodes, currentId, part);
          currentNode.children ??= [];
          currentNodes = currentNode.children;
        });

        const keyNode = findOrCreateNode(currentNodes, fullId, key);

        keyNode.values ??= {};
        keyNode.values[locale] = value;
      }
    }
  }

  return tree;
};
